import * as d3 from 'd3';

const closure = mainApp => {
    mainApp.popSize = function(d, year) {
        var refYear = (((year * 2) / 10) | 0) * 5;
        var pop;
        if (
            mainApp.params.yearScale.domain[0] <= year &&
            year < mainApp.params.yearScale.domain[1]
        ) {
            var refPop = d[refYear.toString()];
            var refRate = d[refYear.toString() + '-' + (refYear + 5).toString()];

            pop = refPop * Math.pow(2.718, (year - refYear) * (refRate / 100));
        } else {
            pop = d[refYear.toString()];
        }

        return pop;
    };

    mainApp.popColor = function(d, year) {
        var refYear = Math.floor((year * 2) / 10) * 5;
        var color;
        var refRate;

        if (
            mainApp.params.yearScale.domain[0] <= year &&
            year < mainApp.params.yearScale.domain[1]
        ) {
            refRate = d[refYear.toString() + '-' + (refYear + 5).toString()];
            color = mainApp.params.scales.color(refRate);
        } else {
            refRate = d[(refYear - 5).toString() + '-' + refYear.toString()];
            color = mainApp.params.scales.color(refRate);
        }
        return color;
    };

    mainApp.year = function(y) {
        mainApp.handle.attr('cx', mainApp.params.scales.year(y));
        mainApp.yearDisp.select('text').text(Math.round(y));
        mainApp.map
            .selectAll('circle')
            .attr('r', function(d) {
                var radius;
                var pop = mainApp.popSize(d, y);
                if (pop >= mainApp.params.bubbleScale.lowestVisible) {
                    radius = mainApp.params.scales.bubble(pop);
                } else {
                    radius = 0;
                }
                return Math.round(10 * radius) / 10 / mainApp.mapScale + 'px';
            })
            .attr('fill', function(d) {
                return mainApp.popColor(d, y);
            });
    };

    mainApp.textWrap = function(text, width) {
        text.each(function() {
            var text = d3.select(this),
                words = text
                    .text()
                    .split(/\s+/)
                    .reverse(),
                word,
                line = [],
                lineNumber = 0,
                lineHeight = 1.5, // ems
                y = text.attr('y'),
                dy = parseFloat(text.attr('dy')),
                tspan = text
                    .text(null)
                    .append('tspan')
                    .attr('x', 0)
                    .attr('y', y)
                    .attr('dy', dy + 'em');
            while ((word = words.pop())) {
                line.push(word);
                tspan.text(line.join(' '));
                if (tspan.node().getComputedTextLength() > width) {
                    line.pop();
                    tspan.text(line.join(' '));
                    line = [word];
                    tspan = text
                        .append('tspan')
                        .attr('x', 0)
                        .attr('y', y)
                        .attr('dy', ++lineNumber * lineHeight + dy + 'em')
                        .text(word);
                }
            }
        });
    };

    mainApp.zoomed = function() {
        mainApp.mapScale = d3.event.transform.k;
        mainApp.map.attr('transform', d3.event.transform);
        mainApp.cities
            .attr('r', function(d) {
                var y = mainApp.yearDisp.select('text').text();
                var pop = mainApp.popSize(d, y);
                var radius;
                if (pop >= mainApp.params.bubbleScale.lowestVisible) {
                    radius = mainApp.params.scales.bubble(pop);
                } else {
                    radius = 0;
                }
                return Math.round(10 * radius) / 10 / mainApp.mapScale + 'px';
            })
            .style('stroke-width', function() {
                return mainApp.params.bubbleStroke.normal / mainApp.mapScale + 'px';
            });

        mainApp.bounds.style('stroke-width', function() {
            return 0.5 / mainApp.mapScale + 'px';
        });

        mainApp.land.style('stroke-width', function() {
            return 0.5 / mainApp.mapScale + 'px';
        });
    };
};

export default closure;
